import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../../translations/resource_translations";
import localeHelpers from "../../../helpers/LocaleHelper";
import {common_strings} from "../../../translations/common_translations";
import ResourceApiService from "../../../api/resource-api-service";
import resourceHelper from "../../../helpers/ResourceHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditTeacherView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            teacher: props.teacher || resourceHelper.emptyTeacher(),
            inputsUpdated: true,
            validation: {
                email: true,
                name: true,
            }
        };
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    teacher: {
                        ...prevState.teacher,
                        name: newValue
                    }
                }));
                break;
            case "input-email":
                this.setState(prevState => ({
                    teacher: {
                        ...prevState.teacher,
                        email: newValue
                    }
                }));
                break;
            case "input-phone":
                this.setState(prevState => ({
                    teacher: {
                        ...prevState.teacher,
                        phone: newValue
                    }
                }));
                break;
            case "input-public-cb":
                this.setState(prevState => ({
                    teacher: {
                        ...prevState.teacher,
                        public: checkBoxValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    teacher: {
                        ...prevState.teacher,
                        note: newValue
                    }
                }));

                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.teacher !== this.props.teacher) {
            this.setState({
                teacher: nextProps.teacher,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.teacher !== this.state.teacher) {
            this.handleValidation();
        }
    }

    updateTeacher(e) {
        e.preventDefault();

        if (this.validationCleared()) {
            this.setState({isLoading: true});

            if (this.state.teacher.id) {
                ResourceApiService.updateTeacher(this.state.teacher)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditTeacherView()
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            } else {
                ResourceApiService.postTeacher(this.state.teacher)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditTeacherView(null, res.id)
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            }
        }
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        {this.state.teacher &&
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.full_name}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.full_name}
                                            className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.teacher.name}
                                            id="input-name"
                                            type="name"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.email}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.email}
                                            className={this.state.validation.email === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.teacher.email}
                                            id="input-email"
                                            type="email"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.phone}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.phone}
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            defaultValue={this.state.teacher.phone}
                                            id="input-phone"
                                            type="tel"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-note"
                                        >
                                            {commonStrings.note}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            id="input-note"
                                            placeholder={commonStrings.note}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.teacher && this.state.teacher.note ? this.state.teacher.note : ''}
                                            rows="3"
                                            type="textarea"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-public-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.teacher.public && this.state.teacher.public === true}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-public-cb">
                                            {resourceStrings.public}
                                        </label>
                                        <div>
                                            <small>{resourceStrings.public_teacher_expl}</small>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                        }

                        {this.props.modal &&
                        <div style={{margin: 16, textAlign: "center"}}>
                            <small><i>*{resourceStrings.update_teacher_later}</i></small>
                        </div>
                        }

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeEditTeacherView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color={this.validationCleared() ? "default" : "secondary"}
                                        disabled={!this.validationCleared()}
                                        size="lg"
                                        onClick={e => this.updateTeacher(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    validateEmail() {

        const email = this.state.teacher.email || "";

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                email: (email.length === 0) || (email.includes("@") && email.includes("."))
            }
        }));
    }

    validateName() {

        const name = this.state.teacher.name || "";

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: name.length >= 2
            }
        }));
    }

    handleValidation() {
        this.validateEmail();
        this.validateName();
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

}

EditTeacherView.propTypes = propTypes;

export default EditTeacherView;